var map = {
	"./alx-ai-starter-kit.js": 51,
	"./alx-frontend-specialization.js": 6092,
	"./amazon-books.js": 5186,
	"./clean-code-principles.js": 3560,
	"./crypto-journey.js": 9797,
	"./debugging-strategies.js": 1542,
	"./dog-breeding-journey.js": 5500,
	"./engineering-productivity.js": 2930,
	"./esl-career-journey.js": 4886,
	"./lean-six-sigma-yellow.js": 4408,
	"./osh-certification.js": 4264,
	"./project-planning.js": 8911,
	"./remote-collaboration.js": 6210,
	"./stanford-data-science-cert.js": 3698
};

function webpackAsyncContext(req) {
	return Promise.resolve().then(() => {
		if(!__webpack_require__.o(map, req)) {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		}

		var id = map[req];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 7250;
module.exports = webpackAsyncContext;